import React, { useState } from 'react';
import { getAnimationState } from 'util/animation';
import './ListItemDropdownContainer.css';

interface Props {
  children: JSX.Element | JSX.Element[];
  list?: JSX.Element;
  classPrefix: string;
  inGuide?: boolean;
  className?: string;
  isExpandedByDefault?: boolean;
  triggerExpandOnClick?: boolean;
}

const ListItemDropdownContainer = ({
  children,
  list,
  classPrefix,
  inGuide = false,
  className = '',
  isExpandedByDefault = false,
  triggerExpandOnClick = false
}: Props) => {
  const [isListExpanded, setIsListExpanded] = useState<boolean | null>(isExpandedByDefault ? true : null);

  let prefixSpecificDropDown: JSX.Element | JSX.Element[];
  if (classPrefix === 'template' || classPrefix === 'set-group') {
    prefixSpecificDropDown = (
      <div
        className={`list_item_material with_dropdown ${
          inGuide ? 'in_materiallist' : ''
        } image-border-container ${classPrefix}-list-item-info`}
        onClick={() => setIsListExpanded(!isListExpanded)}
      >
        {children}
      </div>
    );
  } else if (classPrefix === 'package') {
    prefixSpecificDropDown = (
      <div
        className={`list_item_material with_dropdown ${
          inGuide ? 'in_materiallist lvl_1' : ''
        } image-border-container ${classPrefix}-list-item-info`}
        onClick={() => triggerExpandOnClick && setIsListExpanded(!isListExpanded)}
      >
        {children}
      </div>
    );
  } else {
    prefixSpecificDropDown = (
      <div
        className={`list_item_material with_dropdown ${
          inGuide ? 'in_materiallist' : ''
        } image-border-container ${classPrefix}-list-item-info`}
        onClick={() => triggerExpandOnClick && setIsListExpanded(!isListExpanded)}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      className={`list_item_dropdown list-item-dropdown ${classPrefix}-list-item-dropdown ${getAnimationState(
        isListExpanded,
        'expanded',
        'collapsed'
      )} ${className}`}
    >
      <div className="list_item_flex">
        <div
          className={`item_dropdown item_open ${inGuide ? '' : 'left'} item-dropdown`}
          onClick={() => setIsListExpanded(!isListExpanded)}
        >
          <img src="images/icon_small-left_16.svg" alt="" className={`image_arrow_dropdown_2 image-arrow ${classPrefix}-image-arrow`} />
        </div>
        {prefixSpecificDropDown}

        {isListExpanded && list}
      </div>
    </div>
  );
};

export default ListItemDropdownContainer;
